require.register("common/controllers/workListCtrl", function(exports, require, module){
  $0
  
});

